import { Button, Card, Col, Container, DatePicker, Form, FormCheckbox, FormInput, FormSelect, ListGroup, ListGroupItem, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "shards-react";

import ReactTable from "react-table";
import { setDateForTable, setInputDate } from "../../../utils/date";
import { useRef, useState } from "react";
import { useEffect } from "react";
import {
    get_pay_period_year_list
} from "../../../redux/actions/subscriber/payroll";
import { connect } from "react-redux";
import StandardFormInputFreeWidth from "../../../components/common/StandardFormInputFreeWidth";
import { NavgationPageLocationKey, STANDARD_FORMATS } from "../../../utils/constants";
import { get_base_currency } from "../../../redux/actions/user";
import { generate_invoices_payrecords_payments, get_automation_pay_period_list, get_process_list } from "../../../redux/actions/subscriber/automation";
import { get_currency_list } from "../../../redux/actions/subscriber/invoice";
import { toNumber } from "../../../utils/general";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { setAlert } from "../../../redux/actions/alert";
function GenerateInvoicesAndPayments({
    payPeriodYearList,
    baseCurrency,
    automationPayPeriodList,
    processList,
    currencyList,
    get_pay_period_year_list,
    get_base_currency,
    get_automation_pay_period_list,
    get_process_list,
    generate_invoices_payrecords_payments,
    get_currency_list,
    setAlert,
}) {

    const initialState = {
        processId: 0,
        invoiceDate: '',
        dueDate: '',
        exchangeRateList: [],
        payScheduleId: 0,
        autoUpdatePage: true,
        baseCurrencyRate: 1.00,
        payPeriodIdList: []
    }
    const [year, setYear] = useState(new Date().getFullYear());
    const [paySchedule, setPaySchedule] = useState("All");
    const [dropdownData, setDropdownData] = useState([]);
    const [selectedData, setSelectedData] = useState([]);

    const [formSubmitting, setForSubmitting] = useState(false);
    const [formData, setFormData] = useState({ ...initialState });
    const [tableData, setTableData] = useState([]);
    const IntervalRef = useRef(null);
    const [openModal, setOpenModal] = useState(false);
    const history = useHistory();
    const [processInfo, setProcessInfo] = useState("");

    const toggle = () => {
        setOpenModal(!openModal)
    }

    const groupAndSetDropDownVal = (data) => {
        if (data != null) {
            const uniqueNames = [...new Set(data.map((item) => item.payScheduleName))];
            let options = uniqueNames.map(item => <option key={item} value={item}>{item}</option>)
            setDropdownData(options);
        }
    }

    const resetTableDataSelection = () => {
        const clonedAutomationPayPeriodList = JSON.parse(JSON.stringify(automationPayPeriodList))
        const tableData = (clonedAutomationPayPeriodList || []).filter(pp => {
            pp.processed = Number(formData.processId) === 1 ? pp.processOneCompleted : Number(formData.processId) === 2 ? pp.processTwoCompleted : 'No';
            //pp.checked = formData.payPeriodIdList.includes(pp.refNum)
            pp.checked = formData.payPeriodIdList.includes(pp.refNum + ":" + pp.payScheduleRefNum)
            let selectedYear = String(pp.paymentDate).substring(0, 4);
            return selectedYear === String(year);
        })
        groupAndSetDropDownVal(tableData);
        setTableData([...tableData])
    }

    useEffect(() => {
        const clonedAutomationPayPeriodList = JSON.parse(JSON.stringify(automationPayPeriodList))
        const tableData = (clonedAutomationPayPeriodList || []).filter(pp => {
            pp.processed = Number(formData.processId) === 1 ? pp.processOneCompleted : Number(formData.processId) === 2 ? pp.processTwoCompleted : 'No';
            //pp.checked = formData.payPeriodIdList.includes(pp.refNum)
            pp.checked = formData.payPeriodIdList.includes(pp.refNum + ":" + pp.payScheduleRefNum)
            let selectedYear = String(pp.paymentDate).substring(0, 4);
            if (paySchedule === "All")
                return selectedYear === String(year);
            else
                return selectedYear === String(year) && pp.payScheduleName === paySchedule
        })

        if (dropdownData.length === 0 || (paySchedule !== "All" && tableData.filter(x => x.payScheduleName === paySchedule).length === 0)) {
            groupAndSetDropDownVal(tableData);
        }

        setTableData([...tableData])
        if(formData.processId > 0){
            let title = processList.filter(x => x.processId === Number(formData.processId))[0]?.processName;
            setProcessInfo(title.indexOf("(") > 0 ? title.substr(0, title.indexOf('(') - 1) : "")
        }
    }, [automationPayPeriodList, formData.processId])

    useEffect(() => {
        setPaySchedule("All");
        resetTableDataSelection();
    }, [year])

    useEffect(() => {
        const clonedAutomationPayPeriodList = JSON.parse(JSON.stringify(automationPayPeriodList))
        const tableData = (clonedAutomationPayPeriodList || []).filter(pp => {
            pp.processed = Number(formData.processId) === 1 ? pp.processOneCompleted : Number(formData.processId) === 2 ? pp.processTwoCompleted : 'No';
            //pp.checked = formData.payPeriodIdList.includes(pp.refNum)
            pp.checked = formData.payPeriodIdList.includes(pp.refNum + ":" + pp.payScheduleRefNum)
            let selectedYear = String(pp.paymentDate).substring(0, 4);
            if (paySchedule === "All")
                return selectedYear === String(year);
            else
                return selectedYear === String(year) && pp.payScheduleName === paySchedule
        })

        setTableData([...tableData])
    }, [paySchedule])

    const setSelectionBoxValue = () => {
        const clonedAutomationPayPeriodList = JSON.parse(JSON.stringify(automationPayPeriodList))
        //set selected data
        let checkedData = formData.payPeriodIdList.map((x) => {
            return (clonedAutomationPayPeriodList.filter((y) => { return y.refNum === Number(x.split(":")[0]) 
                && y.payScheduleRefNum === Number(x.split(":")[1])}))[0]
        })
        setSelectedData([ ...checkedData ]);
    }

    const onChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value })
    }

    const isAllChecked = () => {
        if (tableData.length === 0) return false

        for (let data of tableData) {
            if (!data.checked) {
                return false;
            }
        }
        return true;
    }
    const checkAll = (e) => {
        let checkedTableData = tableData.map(data => {
            data.checked = e.target.checked;
            if (data.checked) {
                formData.payPeriodIdList.push(data.refNum + ":" + data.payScheduleRefNum);
            } else {
                formData.payPeriodIdList = [];
            }
            return data;
        })

        setTableData(checkedTableData);
        //set selected data
        let recs = checkedTableData.filter((x) => { return x.checked === true })
        setSelectedData([ ...recs ]);
    }
    const onCheck = (refNum) => {        

        let checkedTableData = tableData.map(data => {
            if (data.refNum + ":" + data.payScheduleRefNum === refNum) {
                data.checked = !data.checked;
                if (data.checked) {
                    if(data.processed !== 'No'){
                        setAlert("Pay period is already processed", "danger");
                        data.checked = !data.checked;
                    }
                    else{
                        formData.payPeriodIdList.push(refNum);
                    }
                } else {
                    let index = formData.payPeriodIdList.indexOf(refNum);
                    if (index > -1) formData.payPeriodIdList.splice(index, 1);
                }
            }

            return data;
        })

        setTableData(checkedTableData);
        setSelectionBoxValue();
    }

    const onRemovingSelection = (refNum) => {
        let index = formData.payPeriodIdList.indexOf(refNum);
        if (index > -1) formData.payPeriodIdList.splice(index, 1);
        setSelectionBoxValue();
        resetTableDataSelection();
    }

    const onChangeStandardInput = (name, value) => {
        formData.exchangeRateList[name] = value;
        setFormData({ ...formData })
    }
    const onMonetaryAmountChanged = (e, decimalPlaces) => {
        formData.exchangeRateList[e.target.name] = toNumber(e.target.value, decimalPlaces);
        setFormData({ ...formData })
    };

    function navigateToAutomationLog(e, refId) {
        e.preventDefault();
        history.push({
            pathname: `/automation-result-details`,
            state: { refNum: refId }
        });
        return false;
    }

    function onContextMenuAutoLogChange(e, refId) {
        if (e.type === 'contextmenu') {
            localStorage.setItem(NavgationPageLocationKey.AutomationLogAddEdit, refId);
        }
    }

    function openAutomationLogInNewTab(e, refId) {
        e.preventDefault();
        localStorage.setItem(NavgationPageLocationKey.AutomationLogAddEdit, refId);
        window.open('/automation-result-details', '_blank');
    }

    const tableColumns = [
        {
            //Added on change for console errors
            Header: <input type="checkbox" checked={isAllChecked()} onClick={(e) => checkAll(e)} onChange={() => { }} />,
            accessor: "action",
            maxWidth: 30,
            minWidth: 30,
            sortable: false,
            Cell: row => <input type="checkbox" checked={row.original.checked} key={row.original.refNum + ":" + row.original.payScheduleRefNum}
                value={row.original.refNum + ":" + row.original.payScheduleRefNum} onChange={() => { }}
                onClick={() => onCheck(row.original.refNum + ":" + row.original.payScheduleRefNum)} />
        },
        {
            Header: "Pay Schedule",
            accessor: "payScheduleName",
            minWidth: 170,
            Cell: row => <div title={row.original.payScheduleName}>{row.original.payScheduleName}</div>
        },
        {
            Header: "Pay Period",
            accessor: "payPeriodName",
            minWidth: 120,
        },
        {
            Header: "Start Date",
            accessor: "startDate",
            minWidth: 100,
            Cell: row =>
                setDateForTable(row.original.startDate),
        },
        {
            Header: "End Date",
            accessor: "endDate",
            minWidth: 95,
            Cell: row =>
                setDateForTable(row.original.endDate),
        },
        {
            Header: "Payment Date",
            accessor: "paymentDate",
            minWidth: 110,
            Cell: row =>
                setDateForTable(row.original.paymentDate),
        },
        {
            Header: "Processed",
            accessor: "processed",
            maxWidth: 85,
            className: "text-center",
            Cell: row => <> { row.original.processed === 'Yes' ? <> 
                <a href="/automation-result-details"
                    onClick={(e) => { openAutomationLogInNewTab(e, Number(formData.processId) === 1 ? row.original.processOneResultId : row.original.processTwoResultId) }}
                    onContextMenu={(e) => onContextMenuAutoLogChange(e, Number(formData.processId) === 1 ? row.original.processOneResultId : row.original.processTwoResultId)}>
                    {'RST-'}{ Number(formData.processId) === 1 ? row.original.processOneResultId : row.original.processTwoResultId}
                </a>
            </> : <>
                <span className={`${row.original.processed === 'No' ? 'text-danger' : 'text-primary'}`}>{row.original.processed}</span>
            </>  } </>
        },
        {
            Header: "Associated Payroll Tax Imported",
            accessor: "payrollTaxImported",
            minWidth: 85,
            className: "text-center",
            Cell: row => <span className={`${row.original.payrollTaxImported === 'Yes' ? 'text-success' : row.original.payrollTaxImported === 'No' ? 'text-danger' : 'text-primary'}`}>{row.original.payrollTaxImported}</span>
        }
    ];

    let payPeriodGrid = <label>No Pay Period List</label>;

    if (automationPayPeriodList) {
        payPeriodGrid = <div className="custom-header m-2 border w-100" ><ReactTable
            columns={tableColumns}
            data={tableData}
            pageSize={Number(tableData.length < 20 ? 20 : tableData.length)}
            showPageSizeOptions={false}
            resizable={false}
            pagination={false}
            showPaginationBottom={false}
            className="w-100 "
            noDataText="No results found"
        /></div>
    }

    const onSubmit = async (e) => {
        e.preventDefault();
        if (formSubmitting) return;
        
        setForSubmitting(true);
        // ----- Logic to prepare new object for auto invoice - Nipul
        
        let revisedList= (formData.payPeriodIdList || []).map((x) => {  
            let item = x.split(":");
            return { payPeriodId : item[0], payScheduleId : item[1] }
        });

        let uniquePayScheduleId = [...new Set(revisedList.map((item) => item.payScheduleId))];
        let paySchedulePayPeriodList = uniquePayScheduleId.map((x) => {
            return {
                payScheduleId: x,
                payPeriodIdList: revisedList.filter((y) => y.payScheduleId === x).map((z) => z.payPeriodId)
            }
        })

        // ------
        let formDataToUpdate = { ...formData }
        formDataToUpdate.payScheduleId = tableData.length > 0 ? tableData[0].payScheduleRefNum : 0;
        formDataToUpdate.invoiceDate = setInputDate(formDataToUpdate.invoiceDate);
        formDataToUpdate.dueDate = setInputDate(formDataToUpdate.dueDate);
        formDataToUpdate.paySchedulePayPeriodList = paySchedulePayPeriodList;

        setFormData({ ...formData, autoUpdatePage: true })
        const generated = await generate_invoices_payrecords_payments(JSON.stringify(formDataToUpdate));
        if (generated) {
            toggle();
        }
        setForSubmitting(false);
    }
    const reset = () => {
        setTableData([...automationPayPeriodList]);
        setFormData({ ...initialState });
    }
    let payPeriodYearListOptions = payPeriodYearList.map(year => <option key={year} value={year}>{year}</option>)
    const processListOptions = (processList || []).map(process => <option key={process.processName} value={process.processId}>{process.processName}</option>)

    const exchangeRateInputs = (currencyList || [])
        .filter(currency => currency !== baseCurrency.currencyCode)
        .map((currency, i) => (
            <>
                <Modal size="md" fade={false} backdrop={false} className="d-flex align-items-center justify-content-center w-auto h-100" open={openModal} toggle={toggle}>
                    <ModalBody className="p-1">
                        <div className="d-flex justify-content-between mx-2"><span><label className="font-weight-bold pr-1">Process:</label>{(processList || []).filter(process => Number(process.processId) === Number(formData.processId))
                            .map(process => process.processName)}
                        </span><i class="fa-solid fa-xmark primary-text bg-white" role="button" onClick={toggle}></i></div>
                        <div className="d-flex justify-content-between mx-2"><span><label className="font-weight-bold pr-1">Is processing for: </label>{
                            tableData.filter((data) => data.checked)
                                .map(data => data.payPeriodName).join(", ")
                        }</span></div>
                        <div className="d-flex justify-content-center p-1 mx-2"><Button onClick={toggle}>Close</Button></div>
                    </ModalBody>
                </Modal>
                <Row className="mb-2 px-4">
                    <Col lg="4">{currency}</Col>
                    <Col lg="8">
                        <FormInput
                            placeholder="0.00"
                            id={`exchangeRate-${i}`}
                            name={i}
                            value={formData.exchangeRateList[i] || ''}
                            onChange={(e) => onMonetaryAmountChanged(e, 2)}
                        />
                    </Col>
                </Row>
            </>
        ));

    const getPayPeriodList = () => {
        //need function for interval set up
        setTimeout(function () {
            get_automation_pay_period_list();
            if (formData.autoUpdatePage && IntervalRef.current === null)
                IntervalRef.current = setInterval(get_automation_pay_period_list, 1000);
        }, 0);
    }

    useEffect(() => {
        if (formData.autoUpdatePage && IntervalRef.current === null) {
            getPayPeriodList();
        } else if (IntervalRef.current) {
            clearInterval(IntervalRef.current);
        }
    }, [formData.autoUpdatePage]);

    useEffect(() => {
        formData.exchangeRateList = Array.from({ length: currencyList.length }, () => '1.00');
        setFormData({ ...formData })
    }, [currencyList])

    useEffect(() => {
        get_currency_list();
        getPayPeriodList();
        get_pay_period_year_list();
        get_base_currency();
        get_process_list();

        return () => {
            if (IntervalRef.current) {
                clearInterval(IntervalRef.current);
            }
        }
    }, [])

    useEffect(() => {
        if(!openModal){
            // Reset the selection and table data
            setSelectedData([]);
            setFormData({ ...formData, payPeriodIdList: [] })
            resetTableDataSelection();
        }
    }, [openModal])

    const getPayScheduleNameAndPeriodName = (item) => {
        let selectedPeriod = selectedData.filter((x) => { return x.refNum === Number(item.split(":")[0]) 
            && x.payScheduleRefNum === Number(item.split(':')[1])})
        return selectedPeriod[0]?.payScheduleName + " - " + selectedPeriod[0]?.payPeriodName
    }

    const preparePayPeriodList = ( formData.payPeriodIdList || [])
        .map(item => <ListGroupItem className="d-flex justify-content-center p-0 pt-2 border-0">
            <Row className="mb-2 w-100 ">
                <Col lg="12">
                    <div className="list-group d-flex">
                        <div>
                            <label className="list-group-item" style={{ padding: "0.5725rem 0.572rem", background: "#f4f4f1"  }}> 
                                { getPayScheduleNameAndPeriodName(item) } 
                            </label>
                        </div>
                        <div style={{ position: "absolute", top: "12px", right: "23px" }}>
                            <i className="fa fa-times-circle" onClick={() => onRemovingSelection(item)} style={{ fontSize: '20px', cursor: "pointer" }}></i>
                        </div>
                    </div>
                </Col>
            </Row>
        </ListGroupItem> )

    return (<>
        <Container fluid className="main-content-container p-4">
            <Form onSubmit={onSubmit}>
                <Card small className="mb-4 w-100 ">
                    <ListGroup flush>
                        <ListGroupItem className="border-card p-3">
                            <Row>
                                <Col
                                    className={"col-12 col-lg-4"}>
                                    <Col sm="10"
                                        className="form-group p-2 m-0">
                                        <label htmlFor="processId">Process</label>
                                        <span aria-hidden="true" className="required"> *</span>
                                        <div>
                                            <FormSelect
                                                id="processId"
                                                name='processId'
                                                required
                                                value={formData.processId}
                                                onChange={onChange}
                                            >
                                                <option>Select Process</option>
                                                {processListOptions}
                                            </FormSelect>
                                        </div>
                                    </Col>
                                    <Col sm="10"
                                        className="form-group p-2 m-0 ">
                                        <label htmlFor="invoiceDate">Invoice Date</label>
                                        <span aria-hidden="true" className="required"> *</span>
                                        <DatePicker
                                            id='invoiceDate'
                                            autoComplete='off'
                                            name='invoiceDate'
                                            dateFormat='yyyy-MM-dd'
                                            value={formData.invoiceDate}
                                            selected={formData.invoiceDate}
                                            required
                                            onChange={(date) =>
                                                setFormData({ ...formData, 'invoiceDate': date })
                                            }
                                            placeholderText="YYYY-MM-DD"
                                        />
                                    </Col>
                                    <Col sm="10"
                                        className="form-group p-2  m-0 w-100">
                                        <label htmlFor="dueDate">Due Date</label>
                                        <span aria-hidden="true" className="required"> *</span>
                                        <DatePicker
                                            id='dueDate'
                                            autoComplete='off'
                                            name='dueDate'
                                            dateFormat='yyyy-MM-dd'
                                            value={formData.dueDate}
                                            selected={formData.dueDate}
                                            required
                                            onChange={(date) =>
                                                setFormData({ ...formData, 'dueDate': date })
                                            }
                                            placeholderText="YYYY-MM-DD"
                                        />
                                    </Col>
                                    <Col sm="10" className="form-group p-2 m-0">
                                        <label>Enter Exchange Rate</label>
                                        <Card small className="mb-2 w-100 ">
                                            <ListGroup flush>
                                                <ListGroupItem className="border-card p-3 d-flex justify-content-center px-4">
                                                    <div>
                                                        <div className="text-center"><label>Subscriber Base Currency: {baseCurrency.currencyCode}</label></div>
                                                        <Row className="mb-2 px-4">
                                                            <Col lg="4">{baseCurrency.currencyCode}</Col>
                                                            <Col lg="8">
                                                                <StandardFormInputFreeWidth
                                                                    id="baseCurrencyRate"
                                                                    name='baseCurrencyRate'
                                                                    dataMaxFracDigits="2"
                                                                    type="text"
                                                                    placeholder="0.00"
                                                                    disabled={true}
                                                                    standardFormat={STANDARD_FORMATS.COMMA_SEPERATED_NUMBER}
                                                                    onChangeStandardInput={() => { }}
                                                                    value={formData.baseCurrencyRate}
                                                                />
                                                            </Col>
                                                        </Row>
                                                        {
                                                            exchangeRateInputs
                                                        }
                                                    </div>
                                                </ListGroupItem>
                                            </ListGroup>
                                        </Card>
                                    </Col>

                                    <Col sm="10" className="form-group p-2 m-0">
                                        {/* <label>Enter Exchange Rate</label> */}
                                        <Card small className="mb-2 w-100 ">
                                            <ListGroup flush>
                                                <div className="py-1">
                                                    <div className="pl-3 pt-1 border-bottom"><label><b> Selected Pay Periods </b></label></div>
                                                    <div className="selectedPayPeriodsContainer">
                                                    { preparePayPeriodList }
                                                    </div>
                                                </div>
                                            </ListGroup>
                                        </Card>
                                    </Col>

                                    <Col sm="10"
                                        className="form-group p-0 m-0 text-center">
                                        <div className="mb-2">
                                            <Button className="mx-2">Run Process</Button>
                                            <Button onClick={reset}>Reset</Button>
                                        </div>
                                        <span>
                                            <div className="text-center pr-4 mr-1">
                                                <FormCheckbox
                                                    value={formData.autoUpdatePage}
                                                    id="autoUpdatePage"
                                                    name='autoUpdatePage'
                                                    className="d-inline"
                                                    checked={formData.autoUpdatePage}
                                                    onChange={() => setFormData({ ...formData, autoUpdatePage: !formData.autoUpdatePage })}>
                                                </FormCheckbox>
                                                <label htmlFor="autoUpdatePage">Auto Update Page</label>
                                            </div>
                                        </span>
                                    </Col>
                                </Col>
                                <Col
                                    className="form-group col-12 col-lg-8 p-2 m-0 d-flex flex-column">
                                    <Row>
                                        <Col lg="4" className="mr-0 pr-0">
                                            <h6 className="page-title font-weight-bold pt-2">Pay Period List - <span className="primary-text">{ processInfo }</span></h6>
                                        </Col>
                                        <Col lg="5" className="mr-0 pr-0">
                                            <label for="year" className="p-2 col-lg-5"> 
                                                Pay Schedule
                                                <span aria-hidden="true" className="required"> *</span>
                                            </label>
                                            <FormSelect id="paySchedule" name='paySchedule'
                                                value={paySchedule} onChange={(e) => setPaySchedule(e.target.value)}
                                                className='form-control custom-select col-lg-7'
                                            >
                                                <option key="all" value="All">All</option>
                                                {dropdownData}
                                            </FormSelect>
                                        </Col>
                                        <Col lg="3">
                                            {(formData.refNum !== 0) && <>
                                                <label for="year" className="p-2 col-lg-4">Year</label>
                                                <FormSelect id="year" name='year' value={year}
                                                    onChange={(e) => setYear(e.target.value)}
                                                    className='form-control custom-select col-lg-8'
                                                >
                                                    {payPeriodYearListOptions}
                                                </FormSelect></>}
                                        </Col>
                                    </Row>
                                    <div className="d-flex align-items-center justify-content-center w-100 h-100 border">
                                        {payPeriodGrid}
                                    </div>
                                </Col>

                            </Row>
                            <Row >
                            </Row>
                        </ListGroupItem>
                    </ListGroup>
                </Card>
            </Form>
        </Container>
    </>)
}


const mapStateToProps = (state) => ({
    paySchedule: state.payroll.paySchedule,
    payFrequencyList: state.payroll.payFrequencyList,
    payPeriodYearList: state.payroll.payPeriodYearList,
    baseCurrency: state.user.baseCurrency,
    automationPayPeriodList: state.automation.automationPayPeriodList,
    processList: state.automation.processList,
    currencyList: state.invoice.currencyList,

});
export default connect(mapStateToProps, {
    get_pay_period_year_list,
    get_base_currency,
    get_automation_pay_period_list,
    get_process_list,
    generate_invoices_payrecords_payments,
    get_currency_list,
    setAlert
})(GenerateInvoicesAndPayments);